import React, { useState } from "react";
import { userRegistrationValidationSchema } from "./Register.schema";
import { useFormik } from "formik";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { PhoneNumberInput } from "./components/PhoneNumberInput/PhoneNumberInput";
import "./Register.css";
import PasswordInput from "../../../../Components/CommonUI/Input/Password";
import logo from "../../../../Assets/Icons/IY VAULT icon-ios.png";
import logoImg from "../../../../Assets/Icons/IY VAULT icon-ios.png";
import { getClientConfig } from "../../../../config/clientConfig";
import {
  RegisterApi,
  RegisterUser,
} from "../../../../Services/AuthenticationService/RegisterApi";
import { RegisterFormValues } from "../../../../Services/AuthenticationService/RegisterApi";
import Loader from "../../../../Components/Loader/Loader";
import { WhiteListEmail } from "../../../../Services/WhiteListService/WhiteListService";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
const initialValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  email: "",
  countryCode: "",
  telephoneNumber: "",
  fullPhone: "",
  password: "",
  confirmPassword: "",
  role: 0,
};

export const Register = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const clientConfig = getClientConfig();
  const BackBtnClick = () => {
    navigate(-1);
  };

  const SubmitBtnClick = async (values: any) => {
    setLoading(true);
    console.log("Form submitted with values:", values);
    const formValues: RegisterFormValues = {
      role: 0,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.confirmPassword,
      telephoneNumber: values.fullPhone,
      companyName: values.companyName,
    };
    // await WhiteListEmail({ email: values.email });
    const apiResponse = await RegisterUser(formValues);
    if (apiResponse.status) {
      AlertMessage({ text: apiResponse.message, type: "success" });
      navigate("/login");
    } else if (!apiResponse.status) {
      AlertMessage({
        text: apiResponse.message || "Registration Failed",
        type: "error",
      });
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,

    validateOnChange: true,
    validationSchema: userRegistrationValidationSchema,

    onSubmit: SubmitBtnClick,
  });

  return (
    <div className="register-container">
      <div className="register-header">
        <div className="back-btn" onClick={BackBtnClick}>
          <IoMdArrowRoundBack />
        </div>
        <div className="register-header">
          {/* <img src={logo} alt="IY VAULT Logo" className="register-logo" /> */}
            <img
              src={clientConfig.logo_format_1 || logoImg}
              alt="Logo"
              style={{ width: 90, height: 90 }}
              className="register-logo"
            />
        </div>
      </div>
      <h2 className="register-title">Register</h2>

      <form onSubmit={formik.handleSubmit} className="register-form">
        <table>
          <tbody>
            {/* First Name */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                First Name <span className="start">*</span>
              </td>
              <td>
                <input
                  placeholder="First Name"
                  id="firstName"
                  style={{
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    border: "1px solid #cccccc",
                    paddingLeft: "8px",
                  }}
                  name="firstName"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName && (
                  <div className="error">{formik.errors.firstName}</div>
                )}
              </td>
            </tr>

            {/* Last Name */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                Last Name <span className="start">*</span>
              </td>
              <td>
                <input
                  placeholder="Last Name"
                  id="lastName"
                  style={{
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    border: "1px solid #cccccc",
                    paddingLeft: "8px",
                  }}
                  name="lastName"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <div className="error">{formik.errors.lastName}</div>
                )}
              </td>
            </tr>

            {/* Email */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                Email <span className="start">*</span>
              </td>
              <td>
                <input
                  placeholder="example@iykons.com"
                  id="email"
                  style={{
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    border: "1px solid #cccccc",
                    paddingLeft: "8px",
                  }}
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error">{formik.errors.email}</div>
                )}
              </td>
            </tr>

            {/* Company Name */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                Company Name <span className="start">*</span>
              </td>
              <td>
                <input
                  placeholder="Company Name"
                  id="companyName"
                  name="companyName"
                  type="text"
                  style={{
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    border: "1px solid #cccccc",
                    paddingLeft: "8px",
                  }}
                  onChange={formik.handleChange}
                  value={formik.values.companyName}
                />
                {formik.touched.companyName && formik.errors.companyName && (
                  <div className="error">{formik.errors.companyName}</div>
                )}
              </td>
            </tr>

            {/* Password */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                Password <span className="start">*</span>
              </td>
              <td>
                <PasswordInput
                  value={formik.values.password}
                  onChange={(v) => formik.setFieldValue("password", v)}
                  placeholder="Enter Password"
                  style={{
                    borderColor: "#cccccc",
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    paddingLeft: "8px",
                  }}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="error">{formik.errors.password}</div>
                )}
              </td>
            </tr>

            {/* Confirm Password */}
            <tr>
              <td style={{ fontSize: "15px" }}>
                Confirm Password <span className="start">*</span>
              </td>
              <td>
                <PasswordInput
                  style={{
                    borderColor: "#cccccc",
                    width: "343px",
                    height: "37.6px",
                    borderRadius: "6px",
                    paddingLeft: "8px",
                  }}
                  value={formik.values.confirmPassword}
                  onChange={(value) =>
                    formik.setFieldValue("confirmPassword", value)
                  }
                  placeholder="Confirm Password"
                />
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <div className="error">{formik.errors.confirmPassword}</div>
                  )}
              </td>
            </tr>

            {/* Phone Number */}
            <tr>
              <td style={{ fontSize: "var(--font-size-base)" }}>
                Phone Number <span className="start">*</span>
              </td>
              <td>
                <PhoneNumberInput
                  value={formik.values.fullPhone}
                  onChange={(phone, data) => {
                    formik.setFieldValue("countryCode", data.dialCode);
                    formik.setFieldValue(
                      "telephoneNumber",
                      phone.replace(`+${data.dialCode}`, "")
                    );
                    formik.setFieldValue("fullPhone", phone);
                  }}
                  error={formik.errors.telephoneNumber}
                  touched={formik.touched.telephoneNumber}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <button
          type="submit"
          className={`register-btn ${loading ? "text-black" : ""}`}
          disabled={loading}
        >
          {loading ? "Registering..." : "Register"}
        </button>

        <p className="register-footer">
          Already have an account?{" "}
          <span className="log" onClick={() => navigate("/login")}>
            Login{" "}
          </span>
        </p>
      </form>
    </div>
  );
};
